import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import { SanityImageSource } from '@sanity/image-url/lib/types/types';
import React from 'react';
import { urlFor } from '../fetch-content';

const Experience = styled(Grid)`
  min-height: 196px;
  max-height: 230px;
  width: 123px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 15px;
`;
const ImageDiv = styled.div`
  height: 128px;
  width: 123px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 30px;
`;
const Image = styled.img`
  height: 128px;
  width: 123px;
`;
const Name = styled(Typography)`
  font-family: var(--font-work-sans), sans-serif;
  font-size: 16px;
  line-height: 160%;
  text-align: center;
  color: #000000;
`;
export type ExperienceCardProps = {
  name: string;
  image: SanityImageSource;
};

const ExperienceCard = ({ image, name }: ExperienceCardProps): React.ReactElement => {
  const imageUrl = urlFor(image).url() || '';
  return (
    <Experience>
      <ImageDiv>
        <Image src={imageUrl} alt={name} />
      </ImageDiv>
      <Name>{name}</Name>
    </Experience>
  );
};

export default ExperienceCard;
